"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Item = props => {
  const {
    name,
    url,
    isLast,
    numberOfItems
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ItemWrapper, {
    numberOfItems: numberOfItems,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledLink, {
      isLast: isLast,
      name: name,
      href: url,
      children: name
    })
  });
};
exports.Item = Item;
